/**
 * Constante de configuración de ambiente de producción
 *
 * *Production environment config constant*
 */
export const environment = {
  production: true,
  sdkObjectMock: undefined,
  analyticsObjectMock: undefined,
};
